import {
  API_START,
  API_END,
  FETCH_GET_CURRENT_METEO,
  SET_CURRENT_METEO,
  SET_COMMUNITY_CURRENT_METEO,
  FETCH_GET_FORECAST_METEO,
  SET_FORECAST_METEO,
  FETCH_GET_COMMUNITY_CURRENT_METEO,
  SHARE_WEATHER,
  CLEAR_SHARE_WEATHER,
  SET_SHARE_METEO_RESULT,
  NAVIGATION
} from "../actions/types";

const initialState = {
  isFetchingNow: false,
  isFetching: false,
  meteoNow: null,
  meteo: null,
  shareWeather: null,
  photoUri: null,
  reload: 0
};

export default function meteoReducer(state = initialState, action = {}) {
  switch (action.type) {
    case API_START:
      if (
        action.payload === FETCH_GET_CURRENT_METEO ||
        action.payload === FETCH_GET_COMMUNITY_CURRENT_METEO
      ) {
        return {
          ...state,
          isFetchingNow: true,
          meteoNow: null
        };
      }
      if (action.payload === FETCH_GET_FORECAST_METEO) {
        return {
          ...state,
          isFetching: true,
          meteo: null
        };
      }
      break;

    case NAVIGATION:
      if (action.name === "MeteoScreen") {
        return {
          ...state,
          reload: ++state.reload
        };
      }
      break;

    case SHARE_WEATHER:
      return {
        ...state,
        shareWeather: action.payload,
        photoUri: null
      };

    case SET_SHARE_METEO_RESULT:
      return {
        ...state,
        photoUri: action.payload.photoUri
      };

    case CLEAR_SHARE_WEATHER:
      return {
        ...state,
        shareWeather: null
      };

    case SET_COMMUNITY_CURRENT_METEO:
    case SET_CURRENT_METEO:
      return {
        ...state,
        meteoNow: action.payload
      };

    case SET_FORECAST_METEO:
      return {
        ...state,
        meteo: action.payload
      };

    case API_END:
      if (
        action.payload === FETCH_GET_CURRENT_METEO ||
        action.payload === FETCH_GET_COMMUNITY_CURRENT_METEO
      ) {
        return {
          ...state,
          isFetchingNow: false
        };
      }
      if (action.payload === FETCH_GET_FORECAST_METEO) {
        return {
          ...state,
          isFetching: false
        };
      }
      break;
    default:
      return state;
  }
  return state;
}
